// extracted by mini-css-extract-plugin
module.exports = {"root":"ob_IY97mE","leftBoxIcon":"ob_8aP9Cg","titleChildrenContainer":"ob_TFDDsG","seeAllButton":"ob_ZifZse","viewTypes":"ob_3dK9Tr"};